import { RouteMetadata } from './types';
import { canvasMetadata } from './canvas.metadata';
import { workflowsMetadata } from './workflows.metadata';
import { promptsMetadata } from './prompts.metadata';
import { templatesMetadata } from './templates.metadata';
import { filesMetadata } from './files.metadata';
import { secretsMetadata } from './secrets.metadata';
import { connectionsMetadata } from './connections.metadata';
import { modelsMetadata } from './models.metadata';
import { teamMetadata } from './team.metadata';
import { metricsMetadata } from './metrics.metadata';
import { dashboardsMetadata } from './dashboards.metadata';
import { toolsMetadata } from './tools.metadata';
import { systemAgentsMetadata } from './systemAgents.metadata';
import { skillsMetadata } from './skills.metadata';
import { appsMetadata } from './apps.metadata';
import { adminMetadata } from './admin.metadata';
import { adminPlaybooksMetadata } from './adminPlaybooks.metadata';

/**
 * Combined registry of all route metadata.
 * Routes are ordered from most specific to least specific to ensure correct matching.
 * More specific patterns (with more path segments) should be listed before less specific ones.
 */
export const routeMetadataRegistry: RouteMetadata[] = [
    // Admin playbooks - before admin catch-all (/admin)
    ...adminPlaybooksMetadata,

    // Admin - most specific routes first (before less-specific /admin catch-all)
    ...adminMetadata,

    // Canvas - most specific routes first
    ...canvasMetadata,

    // Workflows - most specific routes first
    ...workflowsMetadata,

    // Prompts - most specific routes first
    ...promptsMetadata,

    // Templates - most specific routes first
    ...templatesMetadata,

    // Files
    ...filesMetadata,

    // Secrets
    ...secretsMetadata,

    // Connections
    ...connectionsMetadata,

    // Models
    ...modelsMetadata,

    // Team
    ...teamMetadata,

    // Metrics
    ...metricsMetadata,

    // Dashboards
    ...dashboardsMetadata,

    // Tools
    ...toolsMetadata,

    // Apps
    ...appsMetadata,

    // Skills
    ...skillsMetadata,

    // System agents
    ...systemAgentsMetadata,
];
